function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTrack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 276 300.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "track2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M203,62.63c34,22,55,60,55,100,0,66-54,120-120,120s-120-54-120-120c0-41,20-78,54-100h0v-6c-37,22-59,62-59,106a125,125,0,0,0,125,125c69,0,124-56,124-125,0-44-22-84-59-106Zm-2,14c-2,8-6,15-10,24,19,15,29,38,29,62,0,45-37,82-82,82-46,0-83-37-83-82a81.4,81.4,0,0,1,29-62c-4-9-7-17-10-24a107,107,0,0,0-43,86c0,59,48,106,107,106a106.5,106.5,0,0,0,63-192Zm-3-38a137,137,0,0,1,78,124c0,76-62,138-138,138a138.13,138.13,0,0,1-61-262C99-12.37,176-13.37,198,38.63Zm-16,79a63.62,63.62,0,0,1,19,45,62.74,62.74,0,0,1-63,63c-35,0-64-28-64-63a60.71,60.71,0,0,1,20-45l-3-5a68.16,68.16,0,0,0-22,50,69,69,0,0,0,138,0,68.16,68.16,0,0,0-22-50Zm-7,11c-12,18-24,34-32,43a6.06,6.06,0,0,1-10,0,318.28,318.28,0,0,1-32-43c-9,9-13,21-13,34a49.51,49.51,0,0,0,50,50,50.15,50.15,0,0,0,50-50A51.27,51.27,0,0,0,175,128.63Zm-74-26a327,327,0,0,0,37,55,518.5,518.5,0,0,0,37-55c9-15,15-30,15-40,0-66-105-64-105,0C85,72.63,92,87.63,101,102.63Z",
    style: {
      fill: "#707070"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack2);
export default __webpack_public_path__ + "static/media/track2.14a3c3dd504e9f9fa968fada697e9bcb.svg";
export { ForwardRef as ReactComponent };